import {FC} from 'react'
import {FlatCard, FlatCardHeader, FlatCardTitle, FlatCardBody} from '../FlatCard'
import * as icons from 'jbc-front/components/icons'
import styles from './Tutorial.scss'

interface TutorialListLink {
  linkIcon: keyof typeof icons
  linkTitle: string
  url: string
}

const tutorialListLink = [
  {
    linkIcon: 'VariousProceduresLine',
    linkTitle: '各種手続き',
    url: 'https://jobcan-lms.zendesk.com/hc/ja/categories/115000170351',
  },
  {
    linkIcon: 'MyNumberLine',
    linkTitle: 'マイナンバー管理',
    url: 'https://jobcan-lms.zendesk.com/hc/ja/sections/115000824232',
  },
  {
    linkIcon: 'StressCheckLine',
    linkTitle: '健康管理',
    url: 'https://jobcan-lms.zendesk.com/hc/ja/categories/360004802512',
  },
  {
    linkIcon: 'YearEndLine',
    linkTitle: '年末調整',
    url: 'https://jobcan-payroll.zendesk.com/hc/ja/categories/360001399833',
  },
  {
    linkIcon: 'EmployeeRegistrationLine',
    linkTitle: '従業員登録',
    url: 'https://jobcan-lms.zendesk.com/hc/ja/categories/115000169812',
  },
  {
    linkIcon: 'DocumentCreationLine',
    linkTitle: '書類作成',
    url: 'https://jobcan-lms.zendesk.com/hc/ja/categories/4409760441369',
  },
  {
    linkIcon: 'SettingLine',
    linkTitle: '設定',
    url: 'https://jobcan-lms.zendesk.com/hc/ja/categories/115000170331',
  },
] as const satisfies TutorialListLink[]

export const Tutorial: FC = () => {
  return (
    <FlatCard>
      <FlatCardHeader border>
        <FlatCardTitle>チュートリアル（各機能の使い方）</FlatCardTitle>
      </FlatCardHeader>
      <FlatCardBody className={styles.tutorial}>
        {tutorialListLink.map((item, index) => {
          const Icon = icons[item.linkIcon]
          return (
            <a href={item.url} key={index} target="_blank" rel="noopener">
              <div className={styles.tutorialIcon}>
                <Icon size={20} color="#666666" />
              </div>
              <div className={styles.tutorialTitle}>{item.linkTitle}</div>
            </a>
          )
        })}
      </FlatCardBody>
    </FlatCard>
  )
}
